import { graphql } from '@/gql';
import type { ServiceAccountsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchServiceAccounts = async ({
  email,
  service,
  isActive,
  isClosed,
  isAutomatedAccount,
  isManualAccount,
  orderBy,
  sortType,
  pagination,
}: ServiceAccountsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query ServiceAccounts(
        $email: String
        $service: String
        $isActive: Boolean
        $isClosed: Boolean
        $isAutomatedAccount: Boolean
        $isManualAccount: Boolean
        $orderBy: String
        $sortType: String
        $pagination: PaginationInputType
      ) {
        serviceAccounts(
          email: $email
          service: $service
          isActive: $isActive
          isClosed: $isClosed
          isAutomatedAccount: $isAutomatedAccount
          isManualAccount: $isManualAccount
          orderBy: $orderBy
          sortType: $sortType
          pagination: $pagination
        ) {
          rows {
            id
            user
            service
            email
            password
            phoneNumber
            isActive
            isClosed
            isAutomatedAccount
            isManualAccount
            cookieExpiry
            createdAt
            updatedAt
            operator {
              id
              firstName
              lastName
            }
          }
          count
        }
      }
    `),
    variables: {
      email,
      service,
      isActive,
      isClosed,
      isAutomatedAccount,
      isManualAccount,
      orderBy,
      sortType,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.serviceAccounts;
};
